import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeOpen: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-open, house"><path d="M14.4754 2.92691C13.0596 1.68273 10.9404 1.68273 9.52457 2.92691L4.27457 7.54054C3.4644 8.25251 3 9.27885 3 10.3574V17.25C3 19.321 4.67893 21 6.75 21H8.25C9.2165 21 10 20.2165 10 19.25V17C10 15.8954 10.8954 15 12 15H12.0902C13.1947 15 14.0902 15.8954 14.0902 17V19.25C14.0902 20.2165 14.8737 21 15.8402 21H17.25C19.3211 21 21 19.321 21 17.25V10.3574C21 9.27885 20.5356 8.25251 19.7254 7.54054L14.4754 2.92691Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeOpen;
